import React from "react";
import Button from "../../../components/ButtonUI";
import "./styles.scss";
import presentationSchema from "./schemas/presentationSchema";
import { addOrModifyExpertise } from "../../../api/medecin";
import { Formik } from "formik";
import { User } from "../../../types/user";
import { userAtom } from "../../../state/auth";
import { useAtom } from "jotai";
import Input from "../../../components/Input";
import makeToast from "../../../components/Snackbar";
import { ReactComponent as Close } from "../../../assets/icons/icon-close.svg";

interface Props {
  openModal: boolean;
  setOpenModal: Function;
  doctorId?: string;
}

export const AddExpertise: React.FC<Props> = ({ openModal, setOpenModal }) => {
  const [user, setUser] = useAtom(userAtom);

  return (
    <div className="fixed inset-0 z-50 outline-none focus:outline-none overflow-x-hidden overflow-y-auto bg-opacity-modal flexCenter">
      <div className="absolute bg-white z-40 top-0 left-0 w-full min-h-screen sm:top-1/3 sm:left-auto sm:w-1/2 sm:min-h-0 cursusAdd">
        
        <Formik
          initialValues={{
            expertise: "",
          }}
          onSubmit={async (values) => {
            try {
              if (!values.expertise)
                return makeToast("warning", "Veuillez saisir votre expertise");
              setOpenModal(!openModal);
              const newUser = await addOrModifyExpertise({
                expertises: { ...values },
              });

              setUser({
                ...user,
                ...newUser,
              } as User);
              if (newUser.id) {
                makeToast("success", "Expertise ajoutée avec succès.");
              } else {
                makeToast("error", "Expertise universitaire à échouher.");
              }
            } catch (err) {
              console.log("[error] add Patient -on Submit :", err);
            }
          }}
          validationSchema={presentationSchema}
        >
          {(props) => {
            const { values, handleChange, handleBlur, handleSubmit } = props;

            return (
              <form
              onSubmit={handleSubmit}
              className="box-border w-full max-w-full min-w-0 px-4 py-20 sm:px-8 sm:py-7"
            >
              <h1 className="mb-10">
                Ajouter un expertise
              </h1>

              <div className="w-full min-w-0 overflow-hidden">
                <Input
                  id="expertise"
                  placeholder="Ecrivez votre expertise ..."
                  value={values.expertise}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  inlineLabel={false}
                  onfocus={true}
                  className=" mb-8 box-border"
                />
              </div>

              <div className="flex w-full min-w-0 items-center gap-3 overflow-hidden">
                <Button
                  status="secondary"
                  width="100px"
                  height="50px"
                  className="flex-shrink-0 mb-4"
                  onClick={() => setOpenModal(false)}
                >
                  Annuler
                </Button>

                <Button
                  status="secondary"
                  width="100px"
                  height="50px"
                  className="flex-shrink-0 mb-4"
                >
                  Valider
                </Button>
              </div>
            </form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default AddExpertise;
